"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var base_1 = require("@celo/contractkit/lib/base");
var mini_kit_1 = require("@celo/contractkit/lib/mini-kit");
var constants_1 = require("../constants");
var common_1 = require("./common");
/**
 * Connectors are our link between a DApp and the users wallet. Each
 * wallet has different semantics and these classes attempt to unify
 * them and present a workable API.
 */
var UnauthenticatedConnector = /*#__PURE__*/function (_common_1$AbstractCon) {
  _inherits(UnauthenticatedConnector, _common_1$AbstractCon);
  function UnauthenticatedConnector(n) {
    var _this;
    _classCallCheck(this, UnauthenticatedConnector);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UnauthenticatedConnector).call(this));
    _this.initialised = true;
    _this.type = constants_1.WalletTypes.Unauthenticated;
    _this.feeCurrency = base_1.CeloContract.GoldToken;
    _this.kit = (0, mini_kit_1.newKit)(n.rpcUrl);
    return _this;
  }
  _createClass(UnauthenticatedConnector, [{
    key: "initialise",
    value: function initialise() {
      this.initialised = true;
      return this;
    }
  }, {
    key: "supportsFeeCurrency",
    value: function supportsFeeCurrency() {
      return false;
    }
  }, {
    key: "startNetworkChangeFromApp",
    value: function startNetworkChangeFromApp(network) {
      this.kit = (0, mini_kit_1.newKit)(network.rpcUrl);
      this.emit(common_1.ConnectorEvents.NETWORK_CHANGED, network.name);
    }
  }, {
    key: "close",
    value: function close() {
      try {
        this.kit.connection.stop();
      } finally {
        this.disconnect();
      }
    }
  }]);
  return UnauthenticatedConnector;
}(common_1.AbstractConnector);
exports.default = UnauthenticatedConnector;